import { ImageScaleView, View, ViewOpts } from '@play-co/timestep-core/ui';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import { getRemainingTimeForCurrentRace } from 'src/replicant/match2/races/races.getters';
import createIntervalEmitter from 'src/lib/createIntervalEmitter';
import { formatDuration } from 'src/replicant/utils/time';
import i18n from 'src/lib/i18n/i18n';
import { now, user } from 'src/StateObserver';

export class RacesTimer extends View {
  private readonly bg: ImageScaleView;
  private readonly text: LangBitmapFontTextView;
  private finished = false;

  constructor(opts: ViewOpts) {
    super({ width: 202, height: 52, ...opts });

    this.bg = new ImageScaleView({
      superview: this,
      width: this.style.width,
      height: this.style.height,
      image: 'assets/ui/match2/races/common/time_frame.png',
      scaleMethod: '3slice',
      sourceSlices: {
        horizontal: { left: 48, right: 24 },
      },
    });

    this.text = new LangBitmapFontTextView({
      superview: this,
      x: 110,
      y: 23,
      centerOnOrigin: true,
      align: 'center',
      verticalAlign: 'center',
      size: 24,
      font: 'Body',
      width: 110,
      height: 30,
      color: '#BF8147',
    });

    createIntervalEmitter(({ user }, now) => ({ user, now })).addListener(
      ({ user, now }) => {
        const timeRemaining = getRemainingTimeForCurrentRace(user, now);
        this.setRemainingTime(timeRemaining);
      },
    );
  }

  public setFinished(finished: boolean) {
    this.finished = finished;
    const timeRemaining = getRemainingTimeForCurrentRace(user(), now());
    this.setRemainingTime(timeRemaining);
  }

  public setRemainingTime(timeRemaining: number) {
    this.text.localeText = () =>
      timeRemaining > 0 && !this.finished
        ? formatDuration(timeRemaining)
        : i18n('match2.races.finished');
  }
}
